import store from '../../utilities/store';
import React, {Component} from 'react';
import {Provider} from 'react-redux';
import FavoriteContainer from './FavoriteContainer';


export default class Favorite extends Component {
  render() {
    return (
      <Provider store={store}>
        <FavoriteContainer {...this.props}></FavoriteContainer>
      </Provider>
    );
  }
}
